<template>
    <div>
      <div class="pointsBanner">
        <img src="static/runtime/images/magic/signIn/pointsBanner.png" alt="">
      </div>
      <div class="signInRules" :style="{height: ($pScreen.width - 30)*1.246 + 'px'}">
          <div class="rulesContent">
            <div v-html="checkinGuideInfo"></div>
          </div>
      </div>
    </div>
</template>

<style>
  .pointsBanner {
    width: 100%;
    position: relative;
    z-index: -1;
  }
  .pointsBanner img {
    width: 100%;
  }
  .signInRules {
    padding-top: 30px;
    margin: 0 15px;
    background: url('../../../../static/runtime/images/magic/signIn/ruleBg.png') no-repeat;
    background-size: 100%;
    margin-top: -30px;
  }
  .signInRules .rulesContent {
    width: 85%;
    margin: 0 auto;
    max-height: 85%;
    overflow: auto;
  }
</style>

<script>
    export default {
        data(){
          return {
            checkinGuideInfo: ''
          }
        },
        created(){
           this.checkinGuideInfo = sessionStorage.getItem('checkinGuideInfo');
        },
        mounted(){
               
        },
        methods: {
        
        }  
    }
</script>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/sign-in-rules.vue